import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=c8afee54&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"
import style0 from "./SubmitForm.vue?vue&type=style&index=0&id=c8afee54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afee54",
  null
  
)

export default component.exports